export const handelOpenModalFinalizeRegistration = () => ({
    type: 'OPEN_MODAL_FINALIZE_REGISTRATION'
});
export const handelCloseModalFinalizeRegistration = () => ({
    type: 'CLOSE_MODAL_FINALIZE_REGISTRATION'
});
export const actionChangeInputsFinalizeRegistration = (name,value) => ({
    type: 'CHANGE_INPUTS_FINALIZE_REGISTRATION',name,value
});